import { takeEvery, put } from "redux-saga/effects";
import { SET_USER_DATA, USER_LIST, SET_TAGS, TAG_CREATED, TAG_UPDATED, TAG_DELETED, TAG_ASSIGNED, TAG_REMOVED, FETCH_TAGS, CREATE_TAG, UPDATE_TAG, DELETE_TAG, ASSIGN_TAG, REMOVE_TAG } from "./constants";
import { getMyTags, createTag, updateTag, deleteTag, assignTagToQuote, removeTagFromQuote } from "../Api";

function* SagaData() {
  yield takeEvery(USER_LIST, UserList);
  yield takeEvery(FETCH_TAGS, fetchTagsSaga);
  yield takeEvery(CREATE_TAG, createTagSaga);
  yield takeEvery(UPDATE_TAG, updateTagSaga);
  yield takeEvery(DELETE_TAG, deleteTagSaga);
  yield takeEvery(ASSIGN_TAG, assignTagSaga);
  yield takeEvery(REMOVE_TAG, removeTagSaga);
}

function* UserList() {
  // const url: string = ApiLink + "/users";
  // let data: any = yield fetch(url);
  // data = yield data.json();
  yield put({ type: SET_USER_DATA, data: [] });
}

function* fetchTagsSaga(action) {
  try {
    const { token, role } = action.payload;
    const response = yield getMyTags({ token, role });
    yield put({ type: SET_TAGS, payload: response.tags || [] });
  } catch (error) {
    console.error("Error fetching tags:", error);
    yield put({ type: SET_TAGS, payload: [] });
  }
}

function* createTagSaga(action) {
  try {
    const { token, role, name, color } = action.payload;
    const response = yield createTag({ token, role, name, color });
    yield put({ type: TAG_CREATED, payload: response.tag });
    // Refetch tags after creation
    yield put({ type: FETCH_TAGS, payload: { token, role } });
  } catch (error) {
    console.error("Error creating tag:", error);
  }
}

function* updateTagSaga(action) {
  try {
    const { token, role, tagId, name, color } = action.payload;
    const response = yield updateTag({ token, role, tagId, name, color });
    yield put({ type: TAG_UPDATED, payload: response.tag });
    // Refetch tags after update
    yield put({ type: FETCH_TAGS, payload: { token, role } });
  } catch (error) {
    console.error("Error updating tag:", error);
  }
}

function* deleteTagSaga(action) {
  try {
    const { token, role, tagId } = action.payload;
    yield deleteTag({ token, role, tagId });
    yield put({ type: TAG_DELETED, payload: tagId });
    // Refetch tags after deletion
    yield put({ type: FETCH_TAGS, payload: { token, role } });
  } catch (error) {
    console.error("Error deleting tag:", error);
  }
}

function* assignTagSaga(action) {
  try {
    const { token, role, tagId, quoteId } = action.payload;
    const response = yield assignTagToQuote({ token, role, tagId, quoteId });

    if (response.status === 201) {
      yield put({ type: TAG_ASSIGNED, payload: { tagId, quoteId, assignment: response.assignment } });
    }
    // Note: Error handling (including 409 duplicates) is done in the component
  } catch (error) {
    console.error("Error assigning tag:", error);
    // Error handling is done in the component
  }
}

function* removeTagSaga(action) {
  try {
    const { token, role, tagId, quoteId } = action.payload;
    yield removeTagFromQuote({ token, role, tagId, quoteId });
    yield put({ type: TAG_REMOVED, payload: { tagId, quoteId } });
  } catch (error) {
    console.error("Error removing tag:", error);
  }
}

export default SagaData;
